import EmailIcon from "@mui/icons-material/EmailOutlined";
import { Button } from "@mui/material";
import TooltipForDisabledAction from "@entrilia/shared/components/TooltipForDisabledAction";
import { useIntercomContext } from "@entrilia/shared/contexts/IntercomContext";

const ENABLE_PORTAL_MESSAGE = "Hi — I'd like to enable the Investor Portal for our funds. Can you help us get set up?";

const TalkToOurTeamButton = () => {
  const { showNewMessage, isIntercomWidgetLoaded } = useIntercomContext();

  return (
    <TooltipForDisabledAction
      title={isIntercomWidgetLoaded ? undefined : "The chat with our team isn’t available right now."}
      isActionDisabled={!isIntercomWidgetLoaded}
    >
      <Button
        variant="contained"
        startIcon={<EmailIcon />}
        disabled={!isIntercomWidgetLoaded}
        onClick={() => showNewMessage(ENABLE_PORTAL_MESSAGE)}
      >
        Talk to Our Team
      </Button>
    </TooltipForDisabledAction>
  );
};

export default TalkToOurTeamButton;
